// @flow
import React from 'react';
import { NavLink } from 'react-router-dom';
import Typography from '@justpark/ui/src/components/Typography';

import '../../../static/scss/components/ui/link.scss';

type Props = {
  to: string,
  children: any,
  size?: string,
  cypress?: string,
  underline?: boolean
};

const Link = ({
  to,
  children,
  size = 'secondary',
  cypress,
  underline = false
}: Props) => (
  <Typography
    decoration={underline ? 'underline' : ''}
    size={size}
    className="c-link"
  >
    <NavLink to={to} data-cy={cypress}>
      {children}
    </NavLink>
  </Typography>
);

export default Link;
